// extracted by mini-css-extract-plugin
export default {"imageContainerStyle":"styles_imageContainerStyle__aBlfU","imageStyle":"styles_imageStyle__OrowW"};